module.exports = __webpack_public_path__ + "static/media/FuturaPTDemiOblique.63ead96d.otf";